import { useTranslation } from "react-i18next";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { IDashboardWardRank } from "../../../../../@types/admin";
import {
  CHART_AXIS_STROKE,
  CHART_AXIS_TICK_STYLE,
  CHART_GRID_STROKE,
  CHART_PALETTE,
} from "./chartConstants";
import { DashboardTooltip } from "./DashboardTooltip";

interface IProps {
  data: IDashboardWardRank[];
  limit?: number;
}

function shortenName(name: string): string {
  if (name.length <= 28) return name;
  return `${name.slice(0, 26)}…`;
}

export function ActivePatientsPerWardChart({ data, limit = 8 }: IProps) {
  const { t } = useTranslation();

  const chartData = data.slice(0, limit).map((d) => ({
    name: shortenName(d.wardName),
    value: d.activePatients,
  }));

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        layout="vertical"
        data={chartData}
        margin={{ top: 8, right: 24, left: 0, bottom: 8 }}
        barCategoryGap={6}
      >
        <CartesianGrid
          stroke={CHART_GRID_STROKE}
          strokeDasharray="3 3"
          horizontal={false}
        />
        <XAxis
          type="number"
          stroke={CHART_AXIS_STROKE}
          tick={CHART_AXIS_TICK_STYLE}
        />
        <YAxis
          type="category"
          dataKey="name"
          stroke={CHART_AXIS_STROKE}
          tick={CHART_AXIS_TICK_STYLE}
          width={170}
        />
        <Tooltip
          cursor={{ fill: "rgba(117, 98, 168, 0.08)" }}
          content={(p) => (
            <DashboardTooltip
              {...p}
              valueLabel={t("reports_charts_activePatientsValue")}
            />
          )}
        />
        <Bar
          dataKey="value"
          fill={CHART_PALETTE.primary}
          radius={[0, 6, 6, 0]}
          isAnimationActive={false}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}
